import axios from "axios";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Login.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const nav = useNavigate();

  const login = async () => {
    try {
      const res = await axios.post("https://stu168523.webhosting.arden.ac.uk/api/auth/login", {
        email,
        password,
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.role);
      localStorage.setItem("userName", res.data.name);
      localStorage.setItem("userId", res.data.userId);

      nav("/dashboard");
    } catch (error) {
      alert(error.response?.data?.msg || "Login failed");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Left Image Section */}
        <div className="login-image">
          <img
            src="https://images.unsplash.com/photo-1521791136064-7986c2920216"
            alt="Login Illustration"
          />
        </div>

        {/* Right Form Section */}
        <div className="login-form">
          <h2>Welcome Back</h2>
          <p>Please login to continue</p>

          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button onClick={login}>Login</button>
          <div className="login-link">
            Don't have an account? <Link to="/signup">Signup here</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
